
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { SimpleTenantDto, AddSchoolManagerInput, SchoolPermissionSet } from '@/api/service-proxies'

import { userService } from '@/api/userService'
import PagedListBase, { PagedRequestDto } from '@/lib/view-base/paged-list-base'

class Request extends PagedRequestDto {
  UserId!: number
}

@Component({
  name: 'select-record-face-templete',
  components: {},
})
export default class AddSchoolManager extends PagedListBase<Request, SimpleTenantDto> {
  getpage(finishCallback: Function): void {
    throw new Error('Method not implemented.')
  }

  @Prop({ type: Boolean, default: false }) value!: boolean
  @Prop({ type: Number, default: 0 }) userId!: number
  @Prop({ type: String, default: '' }) userName!: string
  @Prop({ type: String, default: '' }) userPhone!: string

  schools: SimpleTenantDto[] = []
  checkList = []
  SchoolName: string = ''
  filterList = []
  isUpdating = false

  created() {}

  activated() {
    this.refresh()
  }

  @Watch('value')
  watchValue() {
    if (this.isDialogVisible && this.userId) {
      this.getSchool()
    }
  }

  SetDisabled(row: any) {
    if (!row.isRelationSchool) {
      row.isMaintainPerson = false
      row.isServiceProvider = false
      return true
    } else {
      row.isMaintainPerson = true
      return false
    }
  }

  @Watch('SchoolName')
  filterSchoolName() {
    this.getSchool()
  }

  get isDialogVisible() {
    this.isUpdating = false
    return this.value
  }

  set isDialogVisible(value: boolean) {
    this.$emit('input', value)
  }

  async getSchool() {
    this.isTableLoading = true
    await userService
      .getAllSchool(this.userId, this.SchoolName)
      .then((result) => {
        console.log(result.items);
        this.list = result.items
        this.showPaging(result)
      })
      .finally(() => {
        this.isTableLoading = false
      })
  }

  //保存学校设置
  saveSchoolSettings() {
    this.isUpdating = true
    var permissionSettings = new AddSchoolManagerInput();
    permissionSettings.userId = this.userId;
    permissionSettings.schoolPermissionSettings = [];

    this.list.filter((ele) => {
      var set = new SchoolPermissionSet();
      console.log(ele.id);
      set.tenantId = ele.id;
      set.isMaintain = ele.isMaintainPerson;
      set.isServiceProvier = ele.isServiceProvider;
      if(ele.isRelationSchool){
        set.isRelation=ele.isRelationSchool;
      }else{
        set.isRelation=false;
      }
      permissionSettings.schoolPermissionSettings.push(set);
    });


    console.log(123);

    userService.addSchoolManager(permissionSettings).then(() => {
      this.$notify.success('关联成功');
      this.isUpdating = false;
      this.$emit('input', false);
    })
  }
}
